import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="news";

export function selectOne(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get',
  })
}

export function selectUpdateList(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectUpdateList/${parameter}`,
    method: 'get',
  })
}

export function selectUpdateById(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectUpdateById/${parameter}`,
    method: 'get',
  })
}


export function confrimUpdate(parameter,status) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/confrimUpdate/${parameter}/${status}`,
    method: 'PUT',
  })
}

export function selectMyUserNumber() {
  return axios({
    url: `/ws/${moduleName}/selectMyUserNumber`,
    method: 'get',
  })
}

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllInsight(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllInsight`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function initInsightsNewsList(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/initInsightsNewsList`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function saveNewLease(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveNewLease`,
    method: 'post',
    data:parameter
  })
}

export function pageVoByCollection(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/pageVoByCollection`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllByProject(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllByProject`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllPageByOwnerId(parameter,id) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllPageByOwnerId/${id}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectAllPageByIntermediaryId(parameter,id) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllPageByIntermediaryId/${id}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function transfer(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/transfer`,
    method: 'post',
    data:parameter
  })
}
export function selectNewsCount(){
  return axios({
    url: `/ws/${moduleName}/newsCount`,
    method: 'get',
  })
}

export function update(parameter){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function newsAmendment(parameter){
  return axios({
    url: `/ws/${moduleName}/newsAmendment`,
    method: 'put',
    data:parameter
  })
}

export function newsTypeStatistic(parameter){
  return axios({
    url: `/ws/${moduleName}/newsTypeStatistic`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryNewStatistics(parameter){
  return axios({
    url: `/ws/${moduleName}/queryNewStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function queryNewPersonStatistics(parameter){
  return axios({
    url: `/ws/${moduleName}/queryNewPersonStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function adminDelete(id,deleteRemarks){
  return axios({
    url: `/ws/${moduleName}/adminDelete`,
    params: {idList:[id]},
    data:{
      deleteRemarks:deleteRemarks
    },
    method: 'delete',
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function deleteObj(id){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: {idList:[id]},
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function exportNewsFile(params){
  return axios({
    url: `/ws/statisticsExport/exportNewsFile`,
    method: 'get',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function exportEmployeePerformanceFile(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/statisticsExport/exportEmployeePerformanceFile`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType:'blob'
  })
}


export function getUserCitys(){
  return axios({
    url: `/ws/${moduleName}/getUserCitys`,
    method: 'get',

  })
}

export default {
  selectAll,
  selectUpdateById,
  confrimUpdate,
  selectMyUserNumber,
  selectAllInsight,
  initInsightsNewsList,
  exportNewsFile,
  insert,
  saveNewLease,
  selectAllByProject,
  selectNewsCount,
  selectAllPageByIntermediaryId,
  selectAllPageByOwnerId,
  pageVoByCollection,
  selectOne,
  exportEmployeePerformanceFile,
  selectUpdateList,
  update,
  newsAmendment,
  delete:deleteObj,
  newsTypeStatistic,
  queryNewStatistics,
  queryNewPersonStatistics,
  adminDelete,
  transfer,
  getUserCitys,
}